import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Note from './Note';
import './styles.scss';
import NotesFooter from './NotesFooter';
import CreateNoteForm from './CreateNoteForm';

export const TAB_NOTES_MODE = {
  LIST: 'LIST',
  CREATE: 'CREATE',
};

const TabNotes = ({ setFooter }) => {
  const messages = useSelector((state) => ({
    tab: state.messagesReducer.tab,
    notes: state.messagesReducer.notes,
    tabNotesMode: state.messagesReducer.tabNotesMode,
  }));
  const { tabNotesMode, tab, notes } = messages;

  useEffect(() => {
    const isNotesTab = Number(tab) === 1;
    if (!isNotesTab) return;

    setFooter(<NotesFooter />);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, tabNotesMode]);
  const notesList = notes.map((n) => (
    <Note key={n?.id || new Date().toUTCString()} note={n} />
  ));

  return (
    <div className="tab-notes__centerer">
      {tabNotesMode === TAB_NOTES_MODE.LIST ? notesList : <CreateNoteForm />}
    </div>
  );
};

TabNotes.propTypes = {
  setFooter: PropTypes.func.isRequired,
};

export default TabNotes;
